export function validEmail(email: string): boolean {
  const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  if (!email) {
    return false;
  }
  let emails = email.split(";")
  let valid = true;
  emails.forEach(e => {
    valid = valid && (!e || pattern.test(e));
  })
  return valid;
}
